<template>
  <!-- prettier-ignore -->
  <div>
    <search-condition searchable :loading="searching" @do-search="search">
      <ns-company v-model="condition.companyId" />
      <n-field-id v-model="condition.customerId" label="customerId" />
      <n-field-id v-model="condition.accountId" label="accountId" />
      <n-field-enum v-model="condition.type" enum-name="CustomerMailType" label="type" all-option />
      <n-field-enum v-model="condition.status" enum-name="IssueStatus" label="status" all-option />
      <n-field-datetime v-model="condition.from" label="from" />
      <n-field-datetime v-model="condition.to" label="to" />
    </search-condition>
    <n-table :total="total" :page-no="pageNo" :page-size="pageSize" :searched="searched" :searching="searching" :has-result="hasResult" @on-page-no="onPageNo" @on-page-size="onPageSize">
      <customer-email-table :records="records" is-active></customer-email-table>
    </n-table>
  </div>
</template>

<script>
import CustomerView from './view';
import PaginateMixin from '@/mixins/paginate-mixin';
import CustomerEmailTable from './CustomerCustomerEmailTable';
import { fetch } from '@/api/customer/customer-customer-email';

export default CustomerView.extend({
  name: 'CustomerCustomerEmailActive',
  components: { CustomerEmailTable },
  mixins: [PaginateMixin],
  props: {
    condition: Object,
  },
  methods: {
    doSearch(params) {
      let p = { ...params, ...this.condition };
      return fetch(p);
    },
    parse(rows) {
      this.records = rows.records;
    },
  },
});
</script>
